import React from 'react';
import { UserCheck } from 'lucide-react';

export const iniciales = (n) => (n || '?').split(/[\s@.]+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('');

export const ResponsableChip = ({ responsable }) => (responsable ? (
  <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-sky-600 text-white text-[9px] font-bold shrink-0"
    title={`Responsable: ${responsable.nombre}`} data-testid="crm-responsable-chip">{iniciales(responsable.nombre)}</span>
) : null);

export const ResponsableSelector = ({ equipo, value, onChange }) => (
  <div className="flex items-center gap-1">
    <UserCheck className="w-4 h-4 text-gray-500" />
    <select className="border rounded-md px-2 py-1 text-xs bg-white max-w-[150px]" value={value || ''}
      onChange={e => onChange(e.target.value)} data-testid="crm-responsable-selector" title="Responsable">
      <option value="">Sin responsable</option>
      {equipo.map(u => <option key={u.id} value={u.id}>{u.nombre}</option>)}
    </select>
  </div>
);
